import React from 'react';
import EducationCard from "./CardLayout";
import {
    Container,
    Row,
    Jumbotron
} from "react-bootstrap";

const Education = ({educations}) => {
    return (  
        <section className="section">
            <Container>
                <Jumbotron fluid className="bg-white">
                    <h2 className="display-4 mb-5 text-center">
                        {educations.heading}
                    </h2>
                    <Row>
                        {
                            educations.data.map(data => {
                                return <EducationCard key={data.role} data={data} />
                            })
                        }
                    </Row>
                </Jumbotron>
            </Container>
        </section>
    );
}
 
export default Education;